import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { merge } from "lodash";

import { getCurrentLang } from "/@/utils/currentLang";
import { normalizeLang } from "/@/utils/normalizeLang";
import en from "./lang/en";
import es from "./lang/es";
import ja from "./lang/ja";
import ko from "./lang/ko";
import zh from "./lang/zh";
import zhHK from "./lang/zh-HK";
import zhTW from "./lang/zh-TW";

const create = async (data: any) => {
	const messages: Record<string, any> = {
		"zh-CN": zh,
		"zh-TW": zhTW,
		"zh-HK": zhHK,
		en,
		es,
		ja,
		ko
	};
	const initialLanguage = getCurrentLang() || "zh-CN";

	Object.keys(data || {}).forEach((key) => {
		const lang = normalizeLang(key);
		if (messages[lang]) {
			merge(messages[lang], data[key]);
		}
	});

	await i18n.use(LanguageDetector).init({
		resources: {
			en: { translation: messages.en },
			"zh-CN": { translation: messages["zh-CN"] },
			"zh-HK": { translation: messages["zh-HK"] || messages["zh-TW"] },
			"zh-TW": { translation: messages["zh-TW"] },
			es: { translation: messages.es },
			ko: { translation: messages.ko },
			"ko-KR": { translation: messages.ko },
			kr: { translation: messages.ko },
			ja: { translation: messages.ja },
			"ja-JP": { translation: messages.ja },
			jp: { translation: messages.ja }
		},
		fallbackLng: "zh-CN",
		supportedLngs: [
			"en",
			"zh-CN",
			"zh-HK",
			"zh-TW",
			"es",
			"ko",
			"ko-KR",
			"kr",
			"ja",
			"ja-JP",
			"jp"
		],
		nonExplicitSupportedLngs: true,
		lng: initialLanguage,
		debug: false,
		react: {
			useSuspense: false
		},
		detection: {
			order: ["querystring", "localStorage", "navigator"],
			lookupQuerystring: "lang",
			lookupLocalStorage: "i18nextLng",
			caches: ["localStorage"]
		}
	});

	await i18n.changeLanguage(initialLanguage);
	return i18n;
};

export default create;
